"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compressJson_1 = __importDefault(require("../compressJson"));
const querystring_1 = __importDefault(require("querystring"));
/** Uses mWater server to get datagrid data to allow sharing with unprivileged users */
class ServerDatagridDataSource {
    options;
    // options:
    //   apiUrl: API url to use for talking to mWater server
    //   client: client id to use for talking to mWater server
    //   share: share id to use for talking to mWater server
    //   datagridId: datagrid id to use on server
    //   rev: revision to use to allow caching
    constructor(options) {
        this.options = options;
    }
    // Get the data that the widget needs. The widget should implement getData method (see above) to get the data from the server
    //  design: design of the widget. Ignored in the case of server-side rendering
    //  filters: array of filters to apply. Each is { table: table id, jsonql: jsonql condition with {alias} for tableAlias. Use injectAlias to correct
    async getRows(design, offset, limit, filters, callback) {
        const query = {
            client: this.options.client,
            share: this.options.share,
            rev: this.options.rev,
            offset,
            limit
        };
        const filtersJson = JSON.stringify(filters);
        const baseUrl = this.options.apiUrl + `datagrids/${this.options.datagridId}/data`;
        try {
            let response;
            // If the filters are too large, we need to send them in the body
            if (filtersJson.length > 5000) {
                response = await fetch(baseUrl + '?' + querystring_1.default.stringify(query), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ filters: (0, compressJson_1.default)(filters) }),
                });
            }
            else {
                query.filters = (0, compressJson_1.default)(filters);
                const url = baseUrl + '?' + querystring_1.default.stringify(query);
                response = await fetch(url);
            }
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            callback(null, data);
        }
        catch (error) {
            console.error(error);
            callback(error);
        }
    }
    async countRows(design, filters, callback) {
        const query = {
            client: this.options.client,
            share: this.options.share,
            rev: this.options.rev
        };
        const filtersJson = JSON.stringify(filters);
        const baseUrl = this.options.apiUrl + `datagrids/${this.options.datagridId}/summary`;
        try {
            let response;
            // If the filters are too large, we need to send them in the body
            if (filtersJson.length > 5000) {
                response = await fetch(baseUrl + '?' + querystring_1.default.stringify(query), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ filters: (0, compressJson_1.default)(filters) }),
                });
            }
            else {
                query.filters = (0, compressJson_1.default)(filters);
                const url = baseUrl + '?' + querystring_1.default.stringify(query);
                response = await fetch(url);
            }
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            callback(null, data?.[0]?.cnt);
        }
        catch (error) {
            console.error(error);
            callback(error);
        }
    }
    getQuickfiltersDataSource() {
        return new ServerQuickfilterDataSource(this.options);
    }
}
exports.default = ServerDatagridDataSource;
class ServerQuickfilterDataSource {
    options;
    // options:
    //   apiUrl: API url to use for talking to mWater server
    //   client: client id to use for talking to mWater server
    //   share: share id to use for talking to mWater server
    //   datagridId: datagrid id to use on server
    //   rev: revision to use to allow caching
    constructor(options) {
        this.options = options;
    }
    // Gets the values of the quickfilter at index
    async getValues(index, expr, filters, offset, limit, callback) {
        const query = {
            client: this.options.client,
            share: this.options.share,
            offset: offset ?? 0,
            limit,
            rev: this.options.rev
        };
        try {
            let response;
            const url = this.options.apiUrl + `datagrids/${this.options.datagridId}/quickfilters/${index}/values`;
            const filtersJson = JSON.stringify(filters);
            // If the filters are too large, we need to send them in the body
            if (filtersJson.length > 5000) {
                query.filters = (0, compressJson_1.default)(filters);
                response = await fetch(url + '?' + querystring_1.default.stringify(query), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ filters: (0, compressJson_1.default)(filters) }),
                });
            }
            else {
                query.filters = filtersJson;
                response = await fetch(url + '?' + querystring_1.default.stringify(query));
            }
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            callback(null, data);
        }
        catch (error) {
            console.error(error);
            callback(error);
        }
    }
}
